/**
 * Amplify Configuration for Admin Panel
 * 
 * This configuration connects to the Cognito User Pool created by the CDK stack.
 * Update these values after deploying the engagement-screen-cdk stack.
 */

// Environment-based configuration
const config = {
  Auth: {
    Cognito: {
      // Replace with actual values from CDK stack outputs
      userPoolId: import.meta.env.VITE_USER_POOL_ID || 'eu-west-1_PLACEHOLDER',
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || 'PLACEHOLDER_CLIENT_ID',
      loginWith: {
        email: true,
        username: true,
      },
      signUpVerificationMethod: 'code' as const,
      userAttributes: {
        email: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 12,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
};

export default config;

// API Configuration
export const apiConfig = {
  adminApiUrl: import.meta.env.VITE_ADMIN_API_URL || 'http://localhost:3001/admin',
  contentApiUrl: import.meta.env.VITE_CONTENT_API_URL || 'http://localhost:3001',
  mediaBucketUrl: import.meta.env.VITE_MEDIA_BUCKET_URL || '',
};
